<script>
	import formBase from '@_system/components/base/form.vue'
	import invoiceConfig from '@/components/reports/reconciliationbankflow/lib/invoice/index.vue'
	export default {
		extends: formBase,
		name: 'invoiceoutputapplyForm',
		props: {

		},
		data() {
			return {
				invoicedata:{}
			}

		},
		render(h) {
			this.$slots.plug = [
				<invoiceConfig ref="invoiceConfig" invoicedata={this.invoicedata} tab={['invoice']} title="发票预览" />	,
			]
			return formBase.render.call(this, h)
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			boxdatapenetrate(e){
				if(e.moduleName == 'invoiceoutput'){
					if(!e.data.invoice_invoiceId){
						this.$message.error('未查询到发票文件')
						return
					}
					//console.log(row)
					this.invoicedata = {
						invoiceNumber:e.data.invoicecode,
						customerId:e.data.invoice_customerId,
						invoiceId:e.data.invoice_invoiceId,
						invoiceType:e.data.invoice_invoiceType
					}
					this.$nextTick(()=>{
						this.$refs.invoiceConfig.modal_show()
					})
					console.log(e)
				}
				
			},
			// tablefieldChange(e) {
			// 	switch (e.moduleName) {
			// 		case 'collection_order':
			// 			if (e.data.column.field == 'orderamount') {
			// 				let table = e.table
			// 				let fullData = table.getTableData().fullData
			// 				let amount = 0
			// 				fullData.forEach((item) => {
			// 					if (item.orderamount) {
			// 						amount += parseFloat(item.orderamount)
			// 					}
			// 				})
							
			// 				this.fApi.setValue('amount', parseFloat(amount).toFixed(4))
			// 			}
			// 			break;
			// 	}
			// },
			// regestEvent(rule, fApi) {
			// 	let $son_collection_goods = this.fApi.el('$son_collection_goods')
			// 	$son_collection_goods.store.form = this
			// 	fApi.updateRule('$son_collection_goods', {
			// 		on: {
			// 			importtemplate: this.collectionGoodsImporttemplate,
			// 		}
			// 	})
			// },



		},
		components: {
			invoiceConfig
		}
	}
</script>
